import React, { FC } from 'react';

import RecoveryAccountProvider from './components/context';
import RecoveryAccountPageBody from './body';

const CsToolRecoveryAccountScreen: FC = () => {
  return (
    <RecoveryAccountProvider>
      <RecoveryAccountPageBody />
    </RecoveryAccountProvider>
  );
};

export default CsToolRecoveryAccountScreen;
